import React from "react";
import { Col, Row, Card, CardBody, Badge } from "reactstrap";
import { FiInfo, FiMail, FiPhone, FiMapPin, FiGlobe, FiUser, FiAward, FiFileText, FiArrowLeft, FiTruck } from "react-icons/fi";
import BackButton from "../button/BackButton";

const ShowingMfgDetails = ({ details, handleLink, history }) => {
  return (
    <div className="mb-4">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-4 px-2">
        <div className="d-flex align-items-center gap-3">
          <div className="bg-primary-soft p-3 rounded-circle shadow-sm">
            <FiInfo size={24} className="text-primary" />
          </div>
          <div>
            <h4 className="fw-bold text-dark mb-0">{details?.name || "Manufacturer Details"}</h4>
            <p className="text-muted small mb-0">Overview & Product Portfolio</p>
          </div>
        </div>
        <BackButton handleClick={() => history.goBack()} />
      </div>

      <Card className="settings-card shadow-sm border-0 overflow-hidden">
        <CardBody className="p-0">
          <Row className="g-0">
            {/* Left: Logo & Basic Status */}
            <Col lg={3} className="bg-light border-end p-4 text-center d-flex flex-column align-items-center justify-content-center">
              <div className="avatar-container shadow-sm border p-3 bg-white rounded-3 mb-3" style={{ width: '160px', height: '160px' }}>
                <img
                  src={details?.logo || ""}
                  alt="Company Logo"
                  className="img-fluid h-100 object-fit-contain"
                />
              </div>
              <h5 className="fw-bold text-dark mb-1">{details?.name}</h5>
              <Badge color="primary" className="user-badge px-3 py-2 bg-primary-soft text-primary">
                {details?.partnerLevel || "Standard Partner"}
              </Badge>
              <div className="mt-3 text-muted small px-3">
                <FiMapPin className="me-1" /> {details?.address || "No address provided"}
              </div>
            </Col>

            {/* Right: Detailed Info Grid */}
            <Col lg={9} className="p-4">
              <h5 className="section-title mb-4">
                <FiInfo className="me-2" /> Company Information
              </h5>
              <Row className="gy-4">
                <Col md={6}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light p-2 rounded-3 text-primary">
                      <FiMail size={18} />
                    </div>
                    <div>
                      <span className="text-muted d-block small fw-600 text-uppercase">Email Address</span>
                      <span className="text-dark fw-500">{details?.email || "N/A"}</span>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light p-2 rounded-3 text-primary">
                      <FiPhone size={18} />
                    </div>
                    <div>
                      <span className="text-muted d-block small fw-600 text-uppercase">Phone Number</span>
                      <span className="text-dark fw-500">{details?.phone || "N/A"}</span>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light p-2 rounded-3 text-primary">
                      <FiGlobe size={18} />
                    </div>
                    <div>
                      <span className="text-muted d-block small fw-600 text-uppercase">Website</span>
                      <a href={details?.websiteLink} target="_blank" rel="noreferrer" className="text-primary fw-500 text-decoration-none">
                        {details?.websiteLink || "N/A"}
                      </a>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light p-2 rounded-3 text-primary">
                      <FiUser size={18} />
                    </div>
                    <div>
                      <span className="text-muted d-block small fw-600 text-uppercase">Sales Representative</span>
                      <span className="text-dark fw-500">{details?.salesRep || "N/A"}</span>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light p-2 rounded-3 text-primary">
                      <FiTruck size={18} />
                    </div>
                    <div>
                      <span className="text-muted d-block small fw-600 text-uppercase">Distributors</span>
                      <div className="d-flex flex-wrap gap-1 mt-1">
                        {details?.distributors?.length > 0 ? (
                          details.distributors.map((dist, idx) => (
                            <Badge 
                              key={idx} 
                              color="light" 
                              className="text-primary border border-primary-soft fw-bold py-1 px-2"
                              style={{ fontSize: '10px' }}
                            >
                              {dist}
                            </Badge>
                          ))
                        ) : (
                          <span className="text-dark fw-500">N/A</span>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light p-2 rounded-3 text-primary">
                      <FiFileText size={18} />
                    </div>
                    <div>
                      <span className="text-muted d-block small fw-600 text-uppercase">Attachments</span>
                      <div 
                        className="text-primary fw-600 pointer text-decoration-underline mt-1"
                        onClick={handleLink}
                      >
                        <FiFileText className="me-1" /> View LOA/LOS Attachment
                      </div>
                    </div>
                  </div>
                </Col>
                
                {details?.notes && (
                  <Col sm={12}>
                    <div className="p-3 bg-light rounded-3 border-start border-4 border-primary mt-2">
                      <span className="text-muted d-block small fw-600 text-uppercase mb-2">Additional Notes</span>
                      <div 
                        className="text-dark small lh-base"
                        dangerouslySetInnerHTML={{ __html: details?.notes }}
                      />
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default ShowingMfgDetails;
